module.exports = __webpack_public_path__ + "static/media/jennifer-pahlka_200x200.d430ef2f.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/assets/img/speakers/jennifer-pahlka_200x200.png
// module id = 260
// module chunks = 0